import { BaseService } from './base.service';

export class DashboardService extends BaseService {
  private memberId: string;

  constructor(memberId: string) {
    super(`/health-story`);
    this.memberId = memberId;
  }

  async getHealthStorySummary(year?: number): Promise<any[]> {
    const query = year ? `?year=${year}` : '';
    return this.get(`/${this.memberId}${query}`);
  }

  async getHealthStoryDetails(year: number): Promise<any> {
    return this.get(`/details/${this.memberId}/${year}`);
  }
}
